// extracted by mini-css-extract-plugin
export var hideEditor = "_jr-2";
export var infoIcon = "_jr-3";
export var label = "_jr-1";
export var labelContainer = "_jr-0";
export var readonlyText = "_jr-4";